import React from "react";
import Progress4Svg from "../../../assets/svgicons/progress-bar/progress_bar_4.svg";

const Progress4 = (props) => {
  return <img src={Progress4Svg} alt="Progress 4" {...props} />;
};

export default Progress4;
